const dropdownMenus = document.querySelectorAll('.dropdown-menu');

dropdownMenus.forEach(menu => {
    menu.addEventListener('click', (e) => {
        e.stopPropagation();
    });
});

const mobileMenuToggler = document.querySelector('.navbar-toggler');
const mobileMenu = document.getElementById('mobileMenu');
const hamburgerIcon = mobileMenuToggler?.querySelector('.icon:first-child');
const closeIcon = mobileMenuToggler?.querySelector('.icon:last-child');

if (mobileMenu && hamburgerIcon && closeIcon) {
    mobileMenu.addEventListener('show.bs.offcanvas', () => {
        hamburgerIcon.style.display = 'none';
        closeIcon.style.display = 'inline';
    });

    mobileMenu.addEventListener('hide.bs.offcanvas', () => {
        const openCollapses = mobileMenu.querySelectorAll('.collapse.show');
        openCollapses.forEach(collapse => {
            collapse.classList.remove('show');
        });

        const expandedToggles = mobileMenu.querySelectorAll('[aria-expanded="true"]');
        expandedToggles.forEach(toggle => {
            toggle.setAttribute('aria-expanded', 'false');
        });

        hamburgerIcon.style.display = 'inline';
        closeIcon.style.display = 'none';
    });
}

